export default __webpack_public_path__ + "static/process4-0205186d759b40df4d49acdf5596f0de.png";